import { render, staticRenderFns } from "./profil_kabupaten.vue?vue&type=template&id=7008bcae&"
import script from "./profil_kabupaten.vue?vue&type=script&lang=js&"
export * from "./profil_kabupaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports